// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

export interface CanonicalSearchEntry {
  id: string;
  name: string;
  kind: string;
  tags: string[];
  aliases: string[];
}

export const CANONICAL_SEARCH_INDEX: CanonicalSearchEntry[] = [
  {
    "id": "anglerfish",
    "name": "Anglerfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "arctic-char",
    "name": "Arctic Char",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "atlantic-mackerel",
    "name": "Atlantic Mackerel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "atlantic-pygmy-octopus",
    "name": "Atlantic Pygmy Octopus",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "atlantic-salmon",
    "name": "Atlantic Salmon",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "barbel",
    "name": "Barbel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "beltfish",
    "name": "Beltfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blackspot-seabream",
    "name": "Blackspot Seabream",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-european-crayfish",
    "name": "Blue European Crayfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bluefin-tuna",
    "name": "Bluefin Tuna",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bluegill",
    "name": "Bluegill",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "burbot",
    "name": "Burbot",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "butterfly-koi",
    "name": "Butterfly Koi",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "chum-salmon",
    "name": "Chum Salmon",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "clownfish",
    "name": "Clownfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-barbel",
    "name": "Common Barbel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-bleak",
    "name": "Common Bleak",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-carp",
    "name": "Common Carp",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-chub",
    "name": "Common Chub",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-octopus",
    "name": "Common Octopus",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-prawn",
    "name": "Common Prawn",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-rudd",
    "name": "Common Rudd",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-shrimp",
    "name": "Common Shrimp",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-whitefish",
    "name": "Common Whitefish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "crucian-carp",
    "name": "Crucian Carp",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "director-common-octopus-w-cinnamon-hat",
    "name": "Director Common Octopus w/ Cinnamon Hat",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "director-pygmy-octopus-w-brown-hat",
    "name": "Director Pygmy Octopus w/ Brown Hat",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "director-pygmy-octopus-w-cyan-hat",
    "name": "Director Pygmy Octopus w/ Cyan Hat",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "director-pygmy-octopus-w-navy-hat",
    "name": "Director Pygmy Octopus w/ Navy Hat",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "edible-frog",
    "name": "Edible Frog",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-crayfish",
    "name": "European Crayfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-eel",
    "name": "European Eel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-flying-squid",
    "name": "European Flying Squid",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-lobster",
    "name": "European Lobster",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-mudminnow",
    "name": "European Mudminnow",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-perch",
    "name": "European Perch",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-plaice",
    "name": "European Plaice",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-smelt",
    "name": "European Smelt",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "false-scad",
    "name": "False Scad",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "freshwater-blenny",
    "name": "Freshwater Blenny",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-king-crab",
    "name": "Frostspore King Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-ocean-sunfish",
    "name": "Frostspore Ocean Sunfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-puffer-fish",
    "name": "Frostspore Puffer Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-seahorse",
    "name": "Frostspore Seahorse",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-whale-shark",
    "name": "Frostspore Whale Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "giant-oarfish",
    "name": "Giant Oarfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "goby",
    "name": "Goby",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-king-crab",
    "name": "Golden King Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "goldfish",
    "name": "Goldfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grayling",
    "name": "Grayling",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "haddock",
    "name": "Haddock",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "hermit-crab",
    "name": "Hermit Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "horse-mackerel",
    "name": "Horse Mackerel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "huchen",
    "name": "Huchen",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "king-crab",
    "name": "King Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "large-pearl-mussel",
    "name": "Large Pearl Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "largemouth-bass",
    "name": "Largemouth Bass",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mediterranean-killifish",
    "name": "Mediterranean Killifish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "minnow",
    "name": "Minnow",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "moonfish",
    "name": "Moonfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mottled-sculpin",
    "name": "Mottled Sculpin",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mud-sunfish",
    "name": "Mud Sunfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mussel",
    "name": "Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "northern-pike",
    "name": "Northern Pike",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "nursehound",
    "name": "Nursehound",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ocean-sunfish",
    "name": "Ocean Sunfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "oriental-shrimp",
    "name": "Oriental Shrimp",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "puffer-fish",
    "name": "Puffer Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pumpkinseed",
    "name": "Pumpkinseed",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rabbit-fish",
    "name": "Rabbit Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-bellied-piranha",
    "name": "Red-Bellied Piranha",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "river-crab",
    "name": "River Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ruffe",
    "name": "Ruffe",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sardine",
    "name": "Sardine",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "scad",
    "name": "Scad",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "schneider",
    "name": "Schneider",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-bass",
    "name": "Sea Bass",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-stickleback",
    "name": "Sea Stickleback",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "seahorse",
    "name": "Seahorse",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "shortfin-mako-shark",
    "name": "Shortfin Mako Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "skipjack-tuna",
    "name": "Skipjack Tuna",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "smooth-hammerhead",
    "name": "Smooth Hammerhead",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "spined-loach",
    "name": "Spined Loach",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "stone-loach",
    "name": "Stone Loach",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "streber",
    "name": "Streber",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "striped-red-mullet",
    "name": "Striped Red Mullet",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "swordfish",
    "name": "Swordfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tadpole",
    "name": "Tadpole",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tench",
    "name": "Tench",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "three-spined-stickleback",
    "name": "Three-Spined Stickleback",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tilapia",
    "name": "Tilapia",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "trout",
    "name": "Trout",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tub-gurnard",
    "name": "Tub Gurnard",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "turbot",
    "name": "Turbot",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wels-catfish",
    "name": "Wels Catfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "zander",
    "name": "Zander",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "alpine-longhorn-beetle",
    "name": "Alpine Longhorn Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "amethyst-flower-beetle",
    "name": "Amethyst Flower Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ant",
    "name": "Ant",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apollo",
    "name": "Apollo",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "asian-lady-beetle",
    "name": "Asian Lady Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "asparagus-beetle",
    "name": "Asparagus Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bagworm-moth",
    "name": "Bagworm Moth",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "beautiful-demoiselle",
    "name": "Beautiful Demoiselle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "beautiful-leopard",
    "name": "Beautiful Leopard",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-morpho",
    "name": "Blue Morpho",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-shieldbug",
    "name": "Blue Shieldbug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bumblebee",
    "name": "Bumblebee",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cabbage-white",
    "name": "Cabbage White",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cerulean-carpenter",
    "name": "Cerulean Carpenter",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "chestnut-tiger",
    "name": "Chestnut Tiger",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cicada",
    "name": "Cicada",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "comet-moth",
    "name": "Comet Moth",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-blue-butterfly",
    "name": "Common Blue Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-brimstone",
    "name": "Common Brimstone",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-whitetail",
    "name": "Common Whitetail",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "conehead-mantis",
    "name": "Conehead Mantis",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "crimson-marsh-glider",
    "name": "Crimson Marsh Glider",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "elegant-flower-beetle",
    "name": "Elegant Flower Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-firebug",
    "name": "European Firebug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fire-colored-beetle",
    "name": "Fire-Colored Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "four-spotted-ladybug",
    "name": "Four-Spotted Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "four-spotted-skimmer",
    "name": "Four-Spotted Skimmer",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-mother-of-pearl",
    "name": "Frostspore Mother-of-Pearl",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-postman-butterfly",
    "name": "Frostspore Postman Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-purple-spotted-swallowtail",
    "name": "Frostspore Purple Spotted Swallowtail",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-queen-alexandras-birdwing",
    "name": "Frostspore Queen Alexandra's Birdwing",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frostspore-sulkowskys-morpho",
    "name": "Frostspore Sulkowsky's Morpho",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "giant-asian-mantis",
    "name": "Giant Asian Mantis",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "gold-grasshopper",
    "name": "Gold Grasshopper",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-jewel-scarab",
    "name": "Golden Jewel Scarab",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-stag-beetle",
    "name": "Golden Stag Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-birdwing",
    "name": "Green Birdwing",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-script-supervisor-bumblebee",
    "name": "Green Script Supervisor Bumblebee",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-tiger-beetle",
    "name": "Green Tiger Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "hercules-beetle",
    "name": "Hercules Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "horned-beetle",
    "name": "Horned Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "katydid",
    "name": "Katydid",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "large-banded-grasshopper",
    "name": "Large Banded Grasshopper",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "large-red-damselfly",
    "name": "Large Red Damselfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mediterranean-mantis",
    "name": "Mediterranean Mantis",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mini-moon-moth",
    "name": "Mini Moon Moth",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "minotaur-beetle",
    "name": "Minotaur Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "morpho-helena",
    "name": "Morpho Helena",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mother-of-pearl",
    "name": "Mother-Of-Pearl",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mourning-cloak",
    "name": "Mourning Cloak",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "old-world-swallowtail",
    "name": "Old World Swallowtail",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-tip",
    "name": "Orange-Tip",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peacock-butterfly",
    "name": "Peacock Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "picasso-bug",
    "name": "Picasso Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-katydid",
    "name": "Pink Katydid",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-script-supervisor-bumblebee",
    "name": "Pink Script Supervisor Bumblebee",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "postman-butterfly",
    "name": "Postman Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-emperor",
    "name": "Purple Emperor",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-script-supervisor-bumblebee",
    "name": "Purple Script Supervisor Bumblebee",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rainbow-stag-beetle",
    "name": "Rainbow Stag Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rajah-brookes-birdwing",
    "name": "Rajah Brooke’s Birdwing",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-script-supervisor-bumblebee",
    "name": "Red Script Supervisor Bumblebee",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "seven-spotted-ladybug",
    "name": "Seven-Spotted Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "siberian-grasshopper",
    "name": "Siberian Grasshopper",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "silver-jewel-scarab",
    "name": "Silver Jewel Scarab",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "spanish-moon-moth",
    "name": "Spanish Moon Moth",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "splay-footed-carpenter",
    "name": "Splay-Footed Carpenter",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "stag-beetle",
    "name": "Stag Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sulkowskys-morpho",
    "name": "Sulkowsky’s Morpho",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunset-morpho",
    "name": "Sunset Morpho",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waroona-cuckoo-bee",
    "name": "Waroona Cuckoo Bee",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wasp-beetle",
    "name": "Wasp Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-witch",
    "name": "White Witch",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "african-olive-pigeon",
    "name": "African Olive Pigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "american-flamingo",
    "name": "American Flamingo",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "amur-falcon",
    "name": "Amur Falcon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "audouins-gull",
    "name": "Audouin’s Gull",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "azores-bullfinch",
    "name": "Azores Bullfinch",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "azure-tit",
    "name": "Azure Tit",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bearded-reedling",
    "name": "Bearded Reedling",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-and-yellow-macaw",
    "name": "Blue-and-yellow Macaw",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-peafowl",
    "name": "Blue Peafowl",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "brown-noddy",
    "name": "Brown Noddy",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cinnamon-ground-dove",
    "name": "Cinnamon Ground Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "common-kestrel",
    "name": "Common Kestrel",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "double-barred-finch",
    "name": "Double-Barred Finch",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eagle-owl",
    "name": "Eagle-Owl",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eastern-bluebird",
    "name": "Eastern Bluebird",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-bullfinch",
    "name": "Eurasian Bullfinch",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-chaffinch",
    "name": "Eurasian Chaffinch",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-collared-dove",
    "name": "Eurasian Collared Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-golden-oriole",
    "name": "Eurasian Golden Oriole",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-nuthatch",
    "name": "Eurasian Nuthatch",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-wigeon",
    "name": "Eurasian Wigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eurasian-wren",
    "name": "Eurasian Wren",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-bee-eater",
    "name": "European Bee-Eater",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-robin",
    "name": "European Robin",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "european-shag",
    "name": "European Shag",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "great-green-macaw",
    "name": "Great Green Macaw",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "great-tit",
    "name": "Great Tit",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "greater-flamingo",
    "name": "Greater Flamingo",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "hawfinch",
    "name": "Hawfinch",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "imperial-shag",
    "name": "Imperial Shag",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jambu-fruit-dove",
    "name": "Jambu Fruit Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "king-eider",
    "name": "King Eider",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lady-amherst-pheasant",
    "name": "Lady Amherst Pheasant",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lears-macaw",
    "name": "Lear's Macaw",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lesser-flamingo",
    "name": "Lesser Flamingo",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "long-eared-owl",
    "name": "Long Eared Owl",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "long-tailed-tit",
    "name": "Long-Tailed Tit",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mallard",
    "name": "Mallard",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "paradise-tanager",
    "name": "Paradise Tanager",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peregrine-falcon",
    "name": "Peregrine Falcon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pied-imperial-pigeon",
    "name": "Pied Imperial Pigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pine-grosbeak",
    "name": "Pine Grosbeak",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-necked-green-pigeon",
    "name": "Pink-Necked Green Pigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-pigeon",
    "name": "Pink Pigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "przevalskis-parrotbill",
    "name": "Przevalski's Parrotbill",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-and-green-macaw",
    "name": "Red-and-green Macaw",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-faced-cormorant",
    "name": "Red Faced Cormorant",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "redpoll",
    "name": "Redpoll",
    "kind": "bird",
    "tags": [],
    "aliases": [
      "redpolis"
    ]
  },
  {
    "id": "regent-bowerbird",
    "name": "Regent Bowerbird",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ruddy-shelduck",
    "name": "Ruddy Shelduck",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "seagull",
    "name": "Seagull",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "silver-throated-tit",
    "name": "Silver-Throated Tit",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "smew",
    "name": "Smew",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "stock-dove",
    "name": "Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tern",
    "name": "Tern",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "verditer-flycatcher",
    "name": "Verditer Flycatcher",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wallaces-fruit-dove",
    "name": "Wallace's Fruit Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-headed-duck",
    "name": "White-Headed Duck",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-wagtail",
    "name": "White Wagtail",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-eurasian-wigeon",
    "name": "Winter Eurasian Wigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-greater-flamingo",
    "name": "Winter Greater Flamingo",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-mallard",
    "name": "Winter Mallard",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-mandarin-duck",
    "name": "Winter Mandarin Duck",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-smew",
    "name": "Winter Smew",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wonga-pigeon",
    "name": "Wonga Pigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "woodchat-shrike",
    "name": "Woodchat Shrike",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-bellied-flycatcher",
    "name": "Yellow Bellied Flycatcher",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "avocado",
    "name": "Avocado",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cacao",
    "name": "Cacao",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "carrot",
    "name": "Carrot",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "corn",
    "name": "Corn",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eggplant",
    "name": "Eggplant",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grape",
    "name": "Grape",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lettuce",
    "name": "Lettuce",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "paddy",
    "name": "Paddy",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple",
    "name": "Pineapple",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "potatoes",
    "name": "Potatoes",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "romaine-lettuce",
    "name": "Romaine Lettuce",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "strawberry",
    "name": "Strawberry",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tea",
    "name": "Tea",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tomato",
    "name": "Tomato",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wheat",
    "name": "Wheat",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-radish",
    "name": "White Radish",
    "kind": "crop",
    "tags": [],
    "aliases": []
  },
  {
    "id": "anthurium",
    "name": "Anthurium",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "calla-lily",
    "name": "Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-calla-lily",
    "name": "Black Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-calla-lily",
    "name": "Orange Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-calla-lily",
    "name": "Peach Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-calla-lily",
    "name": "Pink Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-calla-lily",
    "name": "Purple Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-calla-lily",
    "name": "Red Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-calla-lily",
    "name": "Sunglow Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-highland-poppy",
    "name": "Sunglow Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-calla-lily",
    "name": "White Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-calla-lily",
    "name": "Yellow Calla Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "carnation",
    "name": "Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-carnation",
    "name": "Black Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-carnation",
    "name": "Green Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-carnation",
    "name": "Orange Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-carnation",
    "name": "Peach Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-carnation",
    "name": "Pink Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-carnation",
    "name": "Red Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-carnation",
    "name": "Selene Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-carnation",
    "name": "White Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-carnation",
    "name": "Yellow Carnation",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "corn-poppy",
    "name": "Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-corn-poppy",
    "name": "Red Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-corn-poppy",
    "name": "White Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-corn-poppy",
    "name": "Yellow Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-corn-poppy",
    "name": "Black Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-corn-poppy",
    "name": "Orange Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-corn-poppy",
    "name": "Pink Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-corn-poppy",
    "name": "Purple Corn Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cranesbill",
    "name": "Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "daisy",
    "name": "Daisy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-daisy",
    "name": "Green Daisy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-daisy",
    "name": "Pink Daisy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-daisy",
    "name": "Red Daisy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-daisy",
    "name": "Selene Daisy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-daisy",
    "name": "White Daisy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "dandelion",
    "name": "Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "highland-poppy",
    "name": "Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-highland-poppy",
    "name": "Black Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-highland-poppy",
    "name": "Blue Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-highland-poppy",
    "name": "Green Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-highland-poppy",
    "name": "Orange Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-highland-poppy",
    "name": "Peach Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-highland-poppy",
    "name": "Pink Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-highland-poppy",
    "name": "Red Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-highland-poppy",
    "name": "Selene Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-highland-poppy",
    "name": "White Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-highland-poppy",
    "name": "Yellow Highland Poppy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "hyacinth",
    "name": "Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "laceleaf",
    "name": "Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-laceleaf",
    "name": "Green Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-laceleaf",
    "name": "Orange Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-laceleaf",
    "name": "Peach Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-laceleaf",
    "name": "Pink Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-laceleaf",
    "name": "Red Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-laceleaf",
    "name": "White Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-laceleaf",
    "name": "Yellow Laceleaf",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lily",
    "name": "Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-lily",
    "name": "Black Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-lily",
    "name": "Green Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-lily",
    "name": "Orange Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-lily",
    "name": "Peach Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-lily",
    "name": "Pink Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-lily",
    "name": "Purple Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-lily",
    "name": "Red Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-lily",
    "name": "Selene Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-lily",
    "name": "White Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-lily",
    "name": "Yellow Lily",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "morning-glory",
    "name": "Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-morning-glory",
    "name": "Selene Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-morning-glory",
    "name": "Black Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-morning-glory",
    "name": "Orange Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-morning-glory",
    "name": "Peach Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-morning-glory",
    "name": "Pink Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-morning-glory",
    "name": "Purple Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-morning-glory",
    "name": "Red Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-morning-glory",
    "name": "White Morning Glory",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "moth-orchid",
    "name": "Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pansy",
    "name": "Pansy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-pansy",
    "name": "Black Pansy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-pansy",
    "name": "Orange Pansy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-pansy",
    "name": "Purple Pansy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-pansy",
    "name": "Sunglow Pansy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-pansy",
    "name": "Yellow Pansy",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rose",
    "name": "Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-rose",
    "name": "Black Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-rose",
    "name": "Blue Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-rose",
    "name": "Orange Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-rose",
    "name": "Peach Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-rose",
    "name": "Pink Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-rose",
    "name": "Purple Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-rose",
    "name": "Selene Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-rose",
    "name": "Sunglow Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-rose",
    "name": "White Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-rose",
    "name": "Yellow Rose",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tulip",
    "name": "Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-tulip",
    "name": "Black Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-tulip",
    "name": "Blue Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-tulip",
    "name": "Orange Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-tulip",
    "name": "Peach Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-tulip",
    "name": "Pink Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-tulip",
    "name": "Purple Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-tulip",
    "name": "Sunglow Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-tulip",
    "name": "White Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-tulip",
    "name": "Yellow Tulip",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple",
    "name": "Apple",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo",
    "name": "Bamboo",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-button-mushroom-blue",
    "name": "Bizarre Button Mushroom Blue",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-button-mushroom-green",
    "name": "Bizarre Button Mushroom Green",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-button-mushroom-red",
    "name": "Bizarre Button Mushroom Red",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-oyster-mushroom-orange",
    "name": "Bizarre Oyster Mushroom Orange",
    "kind": "forageable",
    "tags": [],
    "aliases": [
      "bizarre-ogster-mushroom-orange"
    ]
  },
  {
    "id": "bizarre-oyster-mushroom-pink",
    "name": "Bizarre Oyster Mushroom Pink",
    "kind": "forageable",
    "tags": [],
    "aliases": [
      "bizarre-ogster-mushroom-pink"
    ]
  },
  {
    "id": "bizarre-oyster-mushroom-purple",
    "name": "Bizarre Oyster Mushroom Purple",
    "kind": "forageable",
    "tags": [],
    "aliases": [
      "bizarre-ogster-mushroom-purple"
    ]
  },
  {
    "id": "bizarre-penny-bun-pink",
    "name": "Bizarre Penny Bun (Pink)",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-penny-bun-purple",
    "name": "Bizarre Penny Bun (Purple)",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-penny-bun-red",
    "name": "Bizarre Penny Bun (Red)",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-shiitake-blue",
    "name": "Bizarre Shiitake Blue",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bizarre-shiitake-black",
    "name": "Bizarre Shiitake Black",
    "kind": "forageable",
    "tags": [],
    "aliases": [
      "bizarre-shiitak-black"
    ]
  },
  {
    "id": "bizarre-shiitake-red",
    "name": "Bizarre Shiitake Red",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-truffle",
    "name": "Black Truffle",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry",
    "name": "Blueberry",
    "kind": "forageable",
    "tags": [],
    "aliases": [
      "blueberries"
    ]
  },
  {
    "id": "branch",
    "name": "Branch",
    "kind": "forageable",
    "tags": [],
    "aliases": [
      "branches"
    ]
  },
  {
    "id": "burdock",
    "name": "Burdock",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "button-mushroom",
    "name": "Button Mushroom",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fiddlehead",
    "name": "Fiddlehead",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "flawless-fluorite",
    "name": "Flawless Fluorite",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin",
    "name": "Mandarin",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "matsutake",
    "name": "Matsutake",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mustard-greens",
    "name": "Mustard Greens",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange",
    "name": "Orange",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "oyster-mushroom",
    "name": "Oyster Mushroom",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "penny-bun",
    "name": "Penny Bun",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "quality-timber",
    "name": "Quality Timber",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rare-timber",
    "name": "Rare Timber",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry",
    "name": "Raspberry",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "roaming-oak-timber",
    "name": "Roaming Oak Timber",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "shiitake",
    "name": "Shiitake",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "stone",
    "name": "Stone",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tall-mustard",
    "name": "Tall Mustard",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "timber",
    "name": "Timber",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "weed",
    "name": "Weed",
    "kind": "forageable",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bunny",
    "name": "Bunny",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "capybara",
    "name": "Capybara",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "deer",
    "name": "Deer",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "ferret",
    "name": "Ferret",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "fox",
    "name": "Fox",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "llama",
    "name": "Llama",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "penguin",
    "name": "Penguin",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife",
      "event"
    ],
    "aliases": []
  },
  {
    "id": "panda",
    "name": "Panda",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "sea-otter",
    "name": "Sea Otter",
    "kind": "animal",
    "tags": [
      "animal",
      "wildlife"
    ],
    "aliases": []
  },
  {
    "id": "afternoon-tea",
    "name": "Afternoon Tea",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "apple-jam",
    "name": "Apple Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "apple-pie",
    "name": "Apple Pie",
    "kind": "dish",
    "tags": [
      "food",
      "dish",
      "pie",
      "apple"
    ],
    "aliases": []
  },
  {
    "id": "baked-eggplant-w-meat",
    "name": "Baked Eggplant w/ Meat",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": [
      "baked-eggplant-with-meat"
    ]
  },
  {
    "id": "bizarre-food",
    "name": "Bizarre Food",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "bizzare-drink",
    "name": "Bizzare Drink",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": [
      "bizarre-drink"
    ]
  },
  {
    "id": "black-truffle-cream-pasta",
    "name": "Black Truffle Cream Pasta",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "black-truffle-pie",
    "name": "Black Truffle Pie",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "blue-roll-cake",
    "name": "Blue Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "blueberry-jam",
    "name": "Blueberry Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "button-mushroom-pie",
    "name": "Button Mushroom Pie",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "candlelight-dinner",
    "name": "Candlelight Dinner",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "caramel-popcorn-bucket",
    "name": "Caramel Popcorn Bucket",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "carrot-cake",
    "name": "Carrot Cake",
    "kind": "dish",
    "tags": [
      "food",
      "dish",
      "cake",
      "carrot"
    ],
    "aliases": []
  },
  {
    "id": "cheese-cake",
    "name": "Cheese Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": [
      "cheesecake"
    ]
  },
  {
    "id": "chocolate-sauce",
    "name": "Chocolate Sauce",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "coffee",
    "name": "Coffee",
    "kind": "dish",
    "tags": [
      "drink",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "coffee-latte",
    "name": "Coffee Latte",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "colorful-movie-combo",
    "name": "Colorful Movie Combo",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "corn-soup",
    "name": "Corn Soup",
    "kind": "dish",
    "tags": [
      "food",
      "dish",
      "soup",
      "corn"
    ],
    "aliases": []
  },
  {
    "id": "crayfish-sashimi",
    "name": "Crayfish Sashimi",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "deluxe-seafood-platter",
    "name": "Deluxe Seafood Platter",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "fish-and-chips",
    "name": "Fish and Chips",
    "kind": "dish",
    "tags": [
      "food",
      "dish",
      "fish",
      "potato"
    ],
    "aliases": []
  },
  {
    "id": "fish-n-chips",
    "name": "Fish N Chips",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "grape-jam",
    "name": "Grape Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "green-roll-cake",
    "name": "Green Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "grilled-button-mushroom",
    "name": "Grilled Button Mushroom",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "grilled-mushrooms",
    "name": "Grilled Mushrooms",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "grilled-oyster-mushroom",
    "name": "Grilled Oyster Mushroom",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "grilled-penny-bun",
    "name": "Grilled Penny Bun",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "grilled-shiitake-mushroom",
    "name": "Grilled Shiitake Mushroom",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "house-salad",
    "name": "House Salad",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "indigo-roll-cake",
    "name": "Indigo Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "latte",
    "name": "Latte",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "mandarin-jam",
    "name": "Mandarin Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "meat-burger",
    "name": "Meat Burger",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "meat-sauce-pasta",
    "name": "Meat Sauce Pasta",
    "kind": "dish",
    "tags": [
      "food",
      "dish",
      "pasta",
      "meat"
    ],
    "aliases": []
  },
  {
    "id": "mixed-jam",
    "name": "Mixed Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "mushroom-pie",
    "name": "Mushroom Pie",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "onsen-egg",
    "name": "Onsen Egg",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-roll-cake",
    "name": "Orange Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "original-roll-cake",
    "name": "Original Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "oyster-mushroom-pie",
    "name": "Oyster Mushroom Pie",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "penny-bun-pie",
    "name": "Penny Bun Pie",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "picnic-set",
    "name": "Picnic Set",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "pineapple-jam",
    "name": "Pineapple Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "raspberry-jam",
    "name": "Raspberry Jam",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "red-roll-cake",
    "name": "Red Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "romaine-lettuce-taco",
    "name": "Romaine Lettuce Taco",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "rustic-ratatouille",
    "name": "Rustic Ratatouille",
    "kind": "dish",
    "tags": [
      "food",
      "dish",
      "vegetable"
    ],
    "aliases": []
  },
  {
    "id": "salsa-wavy-potato-chips",
    "name": "Salsa Wavy Potato Chips",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "savory-double-combo-bucket",
    "name": "Savory Double Combo Bucket",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "savory-popcorn-bucket",
    "name": "Savory Popcorn Bucket",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "seafood-pizza",
    "name": "Seafood Pizza",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "seafood-risotto",
    "name": "Seafood Risotto",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "shiitake-pie",
    "name": "Shiitake Pie",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "smoked-fish-bagel",
    "name": "Smoked Fish Bagel",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "tiramisu",
    "name": "Tiramisu",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "tomato-sauce",
    "name": "Tomato Sauce",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "violet-roll-cake",
    "name": "Violet Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "wild-bracken-celtuce-taco",
    "name": "Wild Bracken Celtuce Taco",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "wild-burdock-celtuce-taco",
    "name": "Wild Burdock Celtuce Taco",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "wild-garlic-mustard-celtuce-taco",
    "name": "Wild Garlic Mustard Celtuce Taco",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "wild-mustard-greens-celtuce-taco",
    "name": "Wild Mustard Greens Celtuce Taco",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "wild-vegetable-celtuce-taco",
    "name": "Wild Vegetable Celtuce Taco",
    "kind": "dish",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "recipe"
    ],
    "aliases": []
  },
  {
    "id": "winter-frost-season-apple-frosted-pancake",
    "name": "Winter Frost Season: Apple Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-aurora-banquet",
    "name": "Winter Frost Season: Aurora Banquet",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-blueberry-frosted-pancake",
    "name": "Winter Frost Season: Blueberry Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-creamy-white-radish-soup",
    "name": "Winter Frost Season: Creamy White Radish Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-iced-coffee",
    "name": "Winter Frost Season: Iced Coffee",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-iced-latte",
    "name": "Winter Frost Season: Iced Latte",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-mandarin-frosted-pancake",
    "name": "Winter Frost Season: Mandarin Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-original-frosted-pancake",
    "name": "Winter Frost Season: Original Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-raspberry-frosted-pancake",
    "name": "Winter Frost Season: Raspberry Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "winter-frost-season-steak-w-mashed-white-radish",
    "name": "Winter Frost Season: Steak w/ Mashed White Radish",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-roll-cake",
    "name": "Yellow Roll Cake",
    "kind": "dish",
    "tags": [
      "dish",
      "cooking",
      "food"
    ],
    "aliases": []
  },
  {
    "id": "egg",
    "name": "Egg",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "butter",
    "name": "Butter",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "meat",
    "name": "Meat",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "cooking-oil",
    "name": "Cooking Oil",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "any-failed-dish",
    "name": "Any Failed Dish",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "milk",
    "name": "Milk",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "blue-sugar",
    "name": "Blue Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "springday-brown-sugar",
    "name": "Springday Brown Sugar",
    "kind": "ingredient",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "vendor-item"
    ],
    "aliases": []
  },
  {
    "id": "cheese",
    "name": "Cheese",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "coffee-beans",
    "name": "Coffee Beans",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "sweet-duo-bucket",
    "name": "Sweet Duo Bucket",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-sugar",
    "name": "Green Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "indigo-sugar",
    "name": "Indigo Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "pasteurized-egg",
    "name": "Pasteurized Egg",
    "kind": "ingredient",
    "tags": [],
    "aliases": [
      "posteurized-egg"
    ]
  },
  {
    "id": "orange-sugar",
    "name": "Orange Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "red-sugar",
    "name": "Red Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "salsa-sauce",
    "name": "Salsa Sauce",
    "kind": "ingredient",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "vendor-item"
    ],
    "aliases": []
  },
  {
    "id": "violet-sugar",
    "name": "Violet Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "frosted",
    "name": "Frosted",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "yellow-sugar",
    "name": "Yellow Sugar",
    "kind": "ingredient",
    "tags": [
      "sweet",
      "crafted"
    ],
    "aliases": []
  },
  {
    "id": "black-motorcycle",
    "name": "Black Motorcycle",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "black-sedan",
    "name": "Black Sedan",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "blue-sedan",
    "name": "Blue Sedan",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "green-motorcycle",
    "name": "Green Motorcycle",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "pink-motorcycle",
    "name": "Pink Motorcycle",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "pink-sedan",
    "name": "Pink Sedan",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "red-motorcycle",
    "name": "Red Motorcycle",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "simplistic-mountain-bike",
    "name": "Simplistic Mountain Bike",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "white-convertible",
    "name": "White Convertible",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "white-motorcycle",
    "name": "White Motorcycle",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "yellow-sedan",
    "name": "Yellow Sedan",
    "kind": "vehicle",
    "tags": [
      "vehicle"
    ],
    "aliases": []
  },
  {
    "id": "anthurium-seeds",
    "name": "Anthurium Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "calla-lily-seeds",
    "name": "Calla Lily Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "carnation-seeds",
    "name": "Carnation Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "corn-poppy-seeds",
    "name": "Corn Poppy Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "cranesbill-seeds",
    "name": "Cranesbill Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "daisy-seeds",
    "name": "Daisy Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "highland-poppy-seeds",
    "name": "Highland Poppy Seeds",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "hyacinth-seeds",
    "name": "Hyacinth Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "laceleaf-seeds",
    "name": "Laceleaf Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "lily-seeds",
    "name": "Lily Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "morning-glory-seeds",
    "name": "Morning Glory Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "moth-orchid-seeds",
    "name": "Moth Orchid Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "pansy-seeds",
    "name": "Pansy Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "pink-daisy-seed",
    "name": "Pink Daisy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-calla-lily-seed",
    "name": "Red Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-carnation-seed",
    "name": "Red Carnation Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-corn-poppy-seed",
    "name": "Red Corn Poppy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-daisy-seed",
    "name": "Red Daisy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-highland-poppy-seed",
    "name": "Red Highland Poppy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-laceleaft-seed",
    "name": "Red Laceleaf Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-morning-glory-seed",
    "name": "Red Morning Glory Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-pansy-seed",
    "name": "Red Pansy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "romaine-lettuce-seed",
    "name": "Romaine Lettuce Seed",
    "kind": "seed",
    "tags": [
      "event",
      "dreamlight-cinematics",
      "crop"
    ],
    "aliases": []
  },
  {
    "id": "rose-seeds",
    "name": "Rose Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "tulip-seeds",
    "name": "Tulip Seeds",
    "kind": "seed",
    "tags": [
      "seed",
      "flower"
    ],
    "aliases": []
  },
  {
    "id": "avocado-seed",
    "name": "Avocado Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "cacao-seed",
    "name": "Cacao Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "carrot-seed",
    "name": "Carrot Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "corn-seed",
    "name": "Corn Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "eggplant-seed",
    "name": "Eggplant Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "auto-bird-whistle",
    "name": "Auto Bird Whistle",
    "kind": "tool",
    "tags": [
      "tool",
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "axe",
    "name": "Axe",
    "kind": "tool",
    "tags": [
      "tool",
      "gathering"
    ],
    "aliases": []
  },
  {
    "id": "bait",
    "name": "Bait",
    "kind": "tool",
    "tags": [
      "tool",
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "camouflage-bush",
    "name": "Camouflage Bush",
    "kind": "tool",
    "tags": [
      "tool",
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "crafty-repair-kit",
    "name": "Crafty Repair Kit",
    "kind": "tool",
    "tags": [
      "tool",
      "repair"
    ],
    "aliases": []
  },
  {
    "id": "dye",
    "name": "Dye",
    "kind": "tool",
    "tags": [
      "tool"
    ],
    "aliases": []
  },
  {
    "id": "fertilizer",
    "name": "Fertilizer",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "grape-seed",
    "name": "Grape Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "fishing-rod",
    "name": "Fishing Rod",
    "kind": "tool",
    "tags": [
      "tool",
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "free-spirited-coffee-umbrella",
    "name": "Free-Spirited Coffee Umbrella",
    "kind": "tool",
    "tags": [
      "tool"
    ],
    "aliases": []
  },
  {
    "id": "growth-booster",
    "name": "Growth Booster",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "lettuce-seed",
    "name": "Lettuce Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "pineapple-seed",
    "name": "Pineapple Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "potato-seed",
    "name": "Potato Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "strawberry-seed",
    "name": "Strawberry Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "tomato-seed",
    "name": "Tomato Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "wheat-seed",
    "name": "Wheat Seed",
    "kind": "seed",
    "tags": [
      "seed",
      "crop",
      "farming"
    ],
    "aliases": []
  },
  {
    "id": "white-calla-lily-seed",
    "name": "White Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-carnation-seed",
    "name": "White Carnation Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-corn-poppy-seed",
    "name": "White Corn Poppy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-daisy-seed",
    "name": "White Daisy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-highland-poppy-seed",
    "name": "White Highland Poppy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-laceleaft-seed",
    "name": "White Laceleaf Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-morning-glory-seed",
    "name": "White Morning Glory Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-radish-seed",
    "name": "White Radish Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-calla-lily-seed",
    "name": "Yellow Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-carnation-seed",
    "name": "Yellow Carnation Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-corn-poppy-seed",
    "name": "Yellow Corn Poppy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-highland-poppy-seed",
    "name": "Yellow Highland Poppy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-laceleaft-seed",
    "name": "Yellow Laceleaf Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-morning-glory-seed",
    "name": "Yellow Morning Glory Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-pansy-seed",
    "name": "Yellow Pansy Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sugar",
    "name": "Sugar",
    "kind": "ingredient",
    "tags": [
      "food",
      "ingredient",
      "sweetener"
    ],
    "aliases": []
  },
  {
    "id": "amazing-seasoning",
    "name": "Amazing Seasoning",
    "kind": "tool",
    "tags": [
      "tool",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "matcha-powder",
    "name": "Matcha Powder",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "red-bean",
    "name": "Red Bean",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "rice-flour",
    "name": "Rice Flour",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "tea-leaves",
    "name": "Tea Leaves",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "universal-ingredient",
    "name": "Universal Ingredient",
    "kind": "ingredient",
    "tags": [
      "ingredient",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "cat-food",
    "name": "Cat Food",
    "kind": "tool",
    "tags": [
      "tool",
      "pet-food"
    ],
    "aliases": []
  },
  {
    "id": "dog-food",
    "name": "Dog Food",
    "kind": "tool",
    "tags": [
      "tool",
      "pet-food"
    ],
    "aliases": []
  },
  {
    "id": "insect-net",
    "name": "Insect Net",
    "kind": "tool",
    "tags": [
      "tool",
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "master-repair-kit",
    "name": "Master Repair Kit",
    "kind": "tool",
    "tags": [
      "tool",
      "repair"
    ],
    "aliases": []
  },
  {
    "id": "mermaid-fish-attractor",
    "name": "Mermaid Fish Attractor",
    "kind": "tool",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mermaid-perfume",
    "name": "Mermaid Perfume",
    "kind": "tool",
    "tags": [],
    "aliases": []
  },
  {
    "id": "quality-fertilizer",
    "name": "Quality Fertilizer",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "quality-growth-booster",
    "name": "Quality Growth Booster",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "rainbow-bouquet",
    "name": "Rainbow Bouquet",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "rainbow-breeding-powder",
    "name": "Rainbow Breeding Powder",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "repair-kit",
    "name": "Repair Kit",
    "kind": "tool",
    "tags": [],
    "aliases": [
      "repair-kits"
    ]
  },
  {
    "id": "scanner",
    "name": "Scanner",
    "kind": "tool",
    "tags": [
      "tool"
    ],
    "aliases": []
  },
  {
    "id": "tablet",
    "name": "Tablet",
    "kind": "tool",
    "tags": [
      "tool"
    ],
    "aliases": []
  },
  {
    "id": "top-fertilizer",
    "name": "Top Fertilizer",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "top-growth-booster",
    "name": "Top Growth Booster",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "universal-animal-food",
    "name": "Universal Animal Food",
    "kind": "tool",
    "tags": [
      "tool",
      "pet-food"
    ],
    "aliases": []
  },
  {
    "id": "inflatable-insect-attractor",
    "name": "Inflatable Insect Attractor",
    "kind": "tool",
    "tags": [
      "tool",
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "dreamlight-cinematics-popcorn-serving-cart",
    "name": "Dreamlight Cinematics Popcorn Serving Cart",
    "kind": "furniture",
    "tags": [
      "furniture",
      "event"
    ],
    "aliases": []
  },
  {
    "id": "large-flower-bed",
    "name": "Large Flower Bed",
    "kind": "furniture",
    "tags": [
      "furniture",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "large-vivarium",
    "name": "Large Vivarium",
    "kind": "furniture",
    "tags": [
      "furniture",
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "medium-flower-bed",
    "name": "Medium Flower Bed",
    "kind": "furniture",
    "tags": [
      "furniture",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "medium-vivarium",
    "name": "Medium Vivarium",
    "kind": "furniture",
    "tags": [
      "furniture",
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "sense-booster",
    "name": "Sense Booster",
    "kind": "tool",
    "tags": [
      "tool",
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "watering-can",
    "name": "Watering Can",
    "kind": "tool",
    "tags": [
      "tool",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "medium-wall-plant-frame",
    "name": "Medium Wall Plant Frame",
    "kind": "furniture",
    "tags": [
      "furniture",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "planter",
    "name": "Planter",
    "kind": "furniture",
    "tags": [
      "furniture",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "small-flower-bed",
    "name": "Small Flower Bed",
    "kind": "furniture",
    "tags": [
      "furniture",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "small-vivarium",
    "name": "Small Vivarium",
    "kind": "furniture",
    "tags": [
      "furniture",
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "square-flower-bed",
    "name": "Square Flower Bed",
    "kind": "furniture",
    "tags": [
      "furniture",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "apple-verbena-pie",
    "name": "Apple Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "blueberry-verbena-pie",
    "name": "Blueberry Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-black-truffle-patty-burger",
    "name": "Brick Black Truffle Patty Burger",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-apple-shaved-ice",
    "name": "Brick Bowl Apple Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-blueberry-shaved-ice",
    "name": "Brick Bowl Blueberry Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-fruit-shaved-ice",
    "name": "Brick Bowl Fruit Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-grape-shaved-ice",
    "name": "Brick Bowl Grape Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-mandarin-shaved-ice",
    "name": "Brick Bowl Mandarin Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-pineapple-shaved-ice",
    "name": "Brick Bowl Pineapple Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-raspberry-shaved-ice",
    "name": "Brick Bowl Raspberry Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-bowl-strawberry-shaved-ice",
    "name": "Brick Bowl Strawberry Shaved Ice",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-button-mushroom-patty-burger",
    "name": "Brick Button Mushroom Patty Burger",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-fun-combo-set",
    "name": "Brick Fun Combo Set",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-mushroom-patty-burger",
    "name": "Brick Mushroom Patty Burger",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-oyster-mushroom-patty-burger",
    "name": "Brick Oyster Mushroom Patty Burger",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-penny-bun-patty-burger",
    "name": "Brick Penny Bun Patty Burger",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "brick-shiitake-patty-burger",
    "name": "Brick Shiitake Patty Burger",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "colorful-egg-feast",
    "name": "Colorful Egg Feast",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "fruit-verbena-pie",
    "name": "Fruit Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "grape-verbena-pie",
    "name": "Grape Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "grass-cake",
    "name": "Grass Cake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "green-egg",
    "name": "Green Egg",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "heart-puppies-con-panna",
    "name": "Heart Puppies Con Panna",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "aliases": []
  },
  {
    "id": "maltese-canele",
    "name": "Maltese Canelé",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "aliases": []
  },
  {
    "id": "maltese-con-panna",
    "name": "Maltese Con Panna",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "aliases": []
  },
  {
    "id": "mandarin-verbena-pie",
    "name": "Mandarin Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "orange-egg",
    "name": "Orange Egg",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "pillow-shaped-egg-yolk-and-pork-zongzi",
    "name": "Pillow-Shaped Egg Yolk & Pork Zongzi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "aliases": []
  },
  {
    "id": "pillow-shaped-plain-rice-zongzi",
    "name": "Pillow-Shaped Plain Rice Zongzi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "aliases": []
  },
  {
    "id": "pillow-shaped-red-bean-zongzi",
    "name": "Pillow-Shaped Red Bean Zongzi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "aliases": []
  },
  {
    "id": "pineapple-verbena-pie",
    "name": "Pineapple Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "purple-egg",
    "name": "Purple Egg",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "rainbow-heart",
    "name": "Rainbow Heart",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "rainbow-verse"
    ],
    "aliases": []
  },
  {
    "id": "rainbow-spark",
    "name": "Rainbow Spark",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "rainbow-verse"
    ],
    "aliases": []
  },
  {
    "id": "raspberry-verbena-pie",
    "name": "Raspberry Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "retriever-canele",
    "name": "Retriever Canelé",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "aliases": []
  },
  {
    "id": "retriever-con-panna",
    "name": "Retriever Con Panna",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "maltese"
    ],
    "aliases": []
  },
  {
    "id": "springdag-raspberry-black-tea",
    "name": "Springdag Raspberry Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-apple-black-tea",
    "name": "Springday Apple Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-blueberry-black-tea",
    "name": "Springday Blueberry Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-fruit-black-tea",
    "name": "Springday Fruit Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-grape-black-tea",
    "name": "Springday Grape Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-mandarin-black-tea",
    "name": "Springday Mandarin Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-pineapple-black-tea",
    "name": "Springday Pineapple Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "springday-strawberry-black-tea",
    "name": "Springday Strawberry Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "strawberry-jam",
    "name": "Strawberry Jam",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "strawberry-verbena-pie",
    "name": "Strawberry Verbena Pie",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "supreme-movie-meal",
    "name": "Supreme Movie Meal",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "triangle-egg-yolk-and-pork-zongzi",
    "name": "Triangle Egg Yolk & Pork Zongzi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "aliases": []
  },
  {
    "id": "triangle-plain-rice-zongzi",
    "name": "Triangle Plain Rice Zongzi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "aliases": []
  },
  {
    "id": "triangle-red-bean-zongzi",
    "name": "Triangle Red Bean Zongzi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking",
      "event",
      "midsummer-rhyme"
    ],
    "aliases": []
  },
  {
    "id": "blue-european-crayfish-sashimi",
    "name": "Blue European Crayfish Sashimi",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "steamed-golden-king-crab",
    "name": "Steamed Golden King Crab",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "steamed-king-crab",
    "name": "Steamed King Crab",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "apple-milkshake",
    "name": "Apple Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "blueberry-milkshake",
    "name": "Blueberry Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "cocoa-milk-tea",
    "name": "Cocoa Milk Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "cocoa-milkshake",
    "name": "Cocoa Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "grape-milkshake",
    "name": "Grape Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "mandarin-milkshake",
    "name": "Mandarin Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "matcha-milkshake",
    "name": "Matcha Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "mellow-black-tea",
    "name": "Mellow Black Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "mellow-milk-tea",
    "name": "Mellow Milk Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "milkshake",
    "name": "Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "pineapple-milkshake",
    "name": "Pineapple Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "raspberry-milkshake",
    "name": "Raspberry Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "strawberry-milkshake",
    "name": "Strawberry Milkshake",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "daisy-tea",
    "name": "Daisy Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "exquisite-afternoon-tea",
    "name": "Exquisite Afternoon Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "green-milk-tea",
    "name": "Green Milk Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "green-tea",
    "name": "Green Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "matcha-green-milk-tea",
    "name": "Matcha Green Milk Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "rose-tea",
    "name": "Rose Tea",
    "kind": "dish",
    "tags": [
      "recipe",
      "cooking"
    ],
    "aliases": []
  },
  {
    "id": "blue-brick-sparrow",
    "name": "Blue Brick Sparrow",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "purple-brick-sparrow",
    "name": "Purple Brick Sparrow",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "colorful-brick-sparrow",
    "name": "Colorful Brick Sparrow",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "pink-brick-sparrow",
    "name": "Pink Brick Sparrow",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "green-brick-sparrow",
    "name": "Green Brick Sparrow",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "blue-suit-dove",
    "name": "Blue Suit Dove",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "gray-suit-dove",
    "name": "Gray Suit Dove",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "striped-suit-dove",
    "name": "Striped Suit Dove",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "red-suit-dove",
    "name": "Red Suit Dove",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "green-suit-dove",
    "name": "Green Suit Dove",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "green-peafowl",
    "name": "Green Peafowl",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "nest-of-hundreds"
    ],
    "aliases": []
  },
  {
    "id": "white-peafowl",
    "name": "White Peafowl",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "nest-of-hundreds"
    ],
    "aliases": []
  },
  {
    "id": "black-peafowl",
    "name": "Black Peafowl",
    "kind": "bird",
    "tags": [
      "birdwatching",
      "event",
      "nest-of-hundreds"
    ],
    "aliases": []
  },
  {
    "id": "baikal-teal",
    "name": "Baikal Teal",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "inca-tern",
    "name": "Inca Tern",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "chestnut-cheeked-starling",
    "name": "Chestnut-Cheeked Starling",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "blue-headed-quail-dove",
    "name": "Blue-Headed Quail-Dove",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "snowy-owl",
    "name": "Snowy Owl",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "red-browed-finch",
    "name": "Red-Browed Finch",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "atlantic-puffin",
    "name": "Atlantic Puffin",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "blue-footed-booby",
    "name": "Blue-Footed Booby",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "whooper-swan",
    "name": "Whooper Swan",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "black-swan",
    "name": "Black Swan",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "black-stork",
    "name": "Black Stork",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "spectacled-owl",
    "name": "Spectacled Owl",
    "kind": "bird",
    "tags": [
      "birdwatching"
    ],
    "aliases": []
  },
  {
    "id": "director-common-octopus-with-patterned-hat",
    "name": "Director Common Octopus w/ Patterned Hat",
    "kind": "fish",
    "tags": [
      "fishing",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "asian-arowana",
    "name": "Asian Arowana",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "blackspot-sergeant",
    "name": "Blackspot Sergeant",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "lionhead",
    "name": "Lionhead",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "whale-shark",
    "name": "Whale Shark",
    "kind": "fish",
    "tags": [
      "fishing",
      "event",
      "sea-fishing"
    ],
    "aliases": []
  },
  {
    "id": "mahi-mahi",
    "name": "Mahi-Mahi",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "moon-jelly",
    "name": "Moon Jelly",
    "kind": "fish",
    "tags": [
      "fishing",
      "event",
      "sea-fishing"
    ],
    "aliases": []
  },
  {
    "id": "angelfish",
    "name": "Angelfish",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "pink-betta",
    "name": "Pink Betta",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "green-sea-turtle",
    "name": "Green Sea Turtle",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "white-faced-surgeonfish",
    "name": "White-Faced Surgeonfish",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "lionfish",
    "name": "Lionfish",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "blue-and-yellow-wrasse",
    "name": "Blue-and-Yellow Wrasse",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "azure-demoiselle",
    "name": "Azure Demoiselle",
    "kind": "fish",
    "tags": [
      "fishing"
    ],
    "aliases": []
  },
  {
    "id": "golden-script-supervisor-bumblebee",
    "name": "Golden Script Supervisor Bumblebee",
    "kind": "insect",
    "tags": [
      "bug-catching",
      "event",
      "dreamlight-cinematics"
    ],
    "aliases": []
  },
  {
    "id": "yellow-brick-large-red-damselfly",
    "name": "Yellow Brick Large Red Damselfly",
    "kind": "insect",
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "blue-brick-large-red-damselfly",
    "name": "Blue Brick Large Red Damselfly",
    "kind": "insect",
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "purple-brick-large-red-damselfly",
    "name": "Purple Brick Large Red Damselfly",
    "kind": "insect",
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "colorful-brick-large-red-damselfly",
    "name": "Colorful Brick Large Red Damselfly",
    "kind": "insect",
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "pink-brick-large-red-damselfly",
    "name": "Pink Brick Large Red Damselfly",
    "kind": "insect",
    "tags": [
      "bug-catching",
      "event",
      "modular-streets"
    ],
    "aliases": []
  },
  {
    "id": "atlas-beetle",
    "name": "Atlas Beetle",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "orchid-mantis",
    "name": "Orchid Mantis",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "queen-alexandra-s-birdwing",
    "name": "Queen Alexandra's Birdwing",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "greater-asian-lady-beetle",
    "name": "Greater Asian Lady Beetle",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "goliath-beetle",
    "name": "Goliath Beetle",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "red-milkweed-locust",
    "name": "Red Milkweed Locust",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "flamer-skimmer",
    "name": "Flamer Skimmer",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "purple-spotted-swallowtail",
    "name": "Purple Spotted Swallowtail",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "scarce-morpho",
    "name": "Scarce Morpho",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "green-metalwing",
    "name": "Green Metalwing",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "green-snail",
    "name": "Green Snail",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "glasswing-butterfly",
    "name": "Glasswing Butterfly",
    "kind": "insect",
    "tags": [
      "bug-catching"
    ],
    "aliases": []
  },
  {
    "id": "blue-brick-clownfish",
    "name": "Blue Brick Clownfish",
    "kind": "fish",
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "aliases": []
  },
  {
    "id": "colorful-brick-clownfish",
    "name": "Colorful Brick Clownfish",
    "kind": "fish",
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "aliases": []
  },
  {
    "id": "purple-brick-clownfish",
    "name": "Purple Brick Clownfish",
    "kind": "fish",
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "aliases": []
  },
  {
    "id": "red-brick-clownfish",
    "name": "Red Brick Clownfish",
    "kind": "fish",
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "aliases": []
  },
  {
    "id": "green-brick-clownfish",
    "name": "Green Brick Clownfish",
    "kind": "fish",
    "tags": [
      "fish",
      "event",
      "modular-streets",
      "brick"
    ],
    "aliases": []
  },
  {
    "id": "loam",
    "name": "Loam",
    "kind": "material",
    "tags": [
      "material",
      "gardening"
    ],
    "aliases": []
  },
  {
    "id": "ore",
    "name": "Ore",
    "kind": "material",
    "tags": [
      "material"
    ],
    "aliases": []
  },
  {
    "id": "snowball",
    "name": "Snowball",
    "kind": "material",
    "tags": [
      "material",
      "event",
      "winter-frost-season"
    ],
    "aliases": []
  },
  {
    "id": "starfall-shard",
    "name": "Starfall Shard",
    "kind": "material",
    "tags": [
      "material"
    ],
    "aliases": []
  },
  {
    "id": "agrias-butterfly",
    "name": "Agrias Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "alpaca-cupcake",
    "name": "Alpaca Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "alpaca-paw-candy",
    "name": "Alpaca Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "american-paddlefish",
    "name": "American Paddlefish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "amur-catfish",
    "name": "Amur Catfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-cake",
    "name": "Apple Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-cloud-candy",
    "name": "Apple Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-frosted-pancake",
    "name": "Apple Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-hermit-crab",
    "name": "Apple Hermit Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-ice-cream",
    "name": "Apple Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-jam-meatball",
    "name": "Apple Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-juice",
    "name": "Apple Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-pearl-cake",
    "name": "Apple Pearl Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-princess-cake",
    "name": "Apple Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "apple-pudding",
    "name": "Apple Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "audouin-s-gull",
    "name": "Audouin's Gull",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "aurora-banquet",
    "name": "Aurora Banquet",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "baked-eggplant-w-meat-sauce",
    "name": "Baked Eggplant w/ Meat Sauce",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "balloon-morpho",
    "name": "Balloon Morpho",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "balloon-nymphalidae",
    "name": "Balloon Nymphalidae",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "balloon-swallowtail",
    "name": "Balloon Swallowtail",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo-tube-apple-juice",
    "name": "Bamboo Tube Apple Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo-tube-blueberry-juice",
    "name": "Bamboo Tube Blueberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo-tube-dragonfruit-juice",
    "name": "Bamboo Tube Dragonfruit Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo-tube-juice",
    "name": "Bamboo Tube Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo-tube-mandarin-juice",
    "name": "Bamboo Tube Mandarin Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bamboo-tube-raspberry-juice",
    "name": "Bamboo Tube Raspberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bandage-fish",
    "name": "Bandage Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bath-towel-mako-shark",
    "name": "Bath-Towel Mako Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bean-paste-tangyuan",
    "name": "Bean Paste Tangyuan",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "beet",
    "name": "Beet",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "berry-cake",
    "name": "Berry Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "berry-pie",
    "name": "Berry Pie",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-calla-lily-seed",
    "name": "Black Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-cranesbill",
    "name": "Black Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-cranesbill-seed",
    "name": "Black Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-dandelion",
    "name": "Black Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-diamond-mussel",
    "name": "Black Diamond Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-hyacinth",
    "name": "Black Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-moth-orchid",
    "name": "Black Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-rose-seed",
    "name": "Black Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-tulip-seed",
    "name": "Black Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "black-turkey",
    "name": "Black Turkey",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-camping-sparrow",
    "name": "Blue Camping Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-clockwork-sparrow",
    "name": "Blue Clockwork Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-coast",
    "name": "Blue Coast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-cranesbill",
    "name": "Blue Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-cranesbill-seed",
    "name": "Blue Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-dandelion",
    "name": "Blue Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-diamond-mussel",
    "name": "Blue Diamond Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-dung-beetle",
    "name": "Blue Dung Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-floating-dust-bug",
    "name": "Blue Floating Dust Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-hat-stock-dove",
    "name": "Blue Hat Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-hyacinth",
    "name": "Blue Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-jello-fish",
    "name": "Blue Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-light-firefly",
    "name": "Blue Light Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-light-jellyfish",
    "name": "Blue Light Jellyfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-milkweed-beetle",
    "name": "Blue Milkweed Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-moth-orchid",
    "name": "Blue Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-red-betta",
    "name": "Blue & Red Betta",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-rose-seed",
    "name": "Blue Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-starry-stock-dove",
    "name": "Blue Starry Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-starry-swan",
    "name": "Blue Starry Swan",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blue-tulip-seed",
    "name": "Blue Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-cloud-candy",
    "name": "Blueberry Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-frosted-pancake",
    "name": "Blueberry Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-hermit-crab",
    "name": "Blueberry Hermit Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-ice-cream",
    "name": "Blueberry Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-jam-meatball",
    "name": "Blueberry Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-juice",
    "name": "Blueberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-pearl-cake",
    "name": "Blueberry Pearl Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-princess-cake",
    "name": "Blueberry Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-pudding",
    "name": "Blueberry Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "blueberry-toast",
    "name": "Blueberry Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bottled-apple-juice",
    "name": "Bottled Apple Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bottled-blueberry-juice",
    "name": "Bottled Blueberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bottled-iced-milk",
    "name": "Bottled Iced Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bottled-mandarin-juice",
    "name": "Bottled Mandarin Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bottled-raspberry-juice",
    "name": "Bottled Raspberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bourbon-red-turkey",
    "name": "Bourbon Red Turkey",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "brown-camping-sparrow",
    "name": "Brown Camping Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "brown-clockwork-sparrow",
    "name": "Brown Clockwork Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "brown-hat-stock-dove",
    "name": "Brown Hat Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "brown-sauna-hat-sea-turtle",
    "name": "Brown Sauna Hat Sea Turtle",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bunny-cupcake",
    "name": "Bunny Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "bunny-paw-candy",
    "name": "Bunny Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "burdock-celtuce-taco",
    "name": "Burdock Celtuce Taco",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "camping-sparrow",
    "name": "Camping Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "candy-corn-fish",
    "name": "Candy Corn Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cappuccino",
    "name": "Cappuccino",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "capybara-cupcake",
    "name": "Capybara Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "capybara-paw-candy",
    "name": "Capybara Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "carrot-juice",
    "name": "Carrot Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cheese-crayfish-stuffed-crab-claws",
    "name": "Cheese Crayfish Stuffed Crab Claws",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cheesy-baked-eggplants",
    "name": "Cheesy Baked Eggplants",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "chocolate-mooncake",
    "name": "Chocolate Mooncake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cinnamoroll-crepe",
    "name": "Cinnamoroll Crepe",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "claypot-seafood-soup",
    "name": "Claypot Seafood Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "claypot-tomato-soup",
    "name": "Claypot Tomato Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "clockwork-frog",
    "name": "Clockwork Frog",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "clockwork-ladybug",
    "name": "Clockwork Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "clockwork-sparrow",
    "name": "Clockwork Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coal-bug",
    "name": "Coal Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cocoa-bean",
    "name": "Cocoa Bean",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coconut",
    "name": "Coconut",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coconut-ice-cream",
    "name": "Coconut Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coconut-juice",
    "name": "Coconut Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coconut-pudding",
    "name": "Coconut Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coffee-cupcake",
    "name": "Coffee Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coffee-ice-cream",
    "name": "Coffee Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coffee-pudding",
    "name": "Coffee Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "coffee-toast",
    "name": "Coffee Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "colorful-movie-meal",
    "name": "Colorful Movie Meal",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "corn-juice",
    "name": "Corn Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-afternoon-tea",
    "name": "Cozy Afternoon Tea",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-borscht",
    "name": "Cozy Borscht",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-carrot-borscht",
    "name": "Cozy Carrot Borscht",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-classic-meatball",
    "name": "Cozy Classic Meatball",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-corn-borscht",
    "name": "Cozy Corn Borscht",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-custard-sauce",
    "name": "Cozy Custard Sauce",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-potato-borscht",
    "name": "Cozy Potato Borscht",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cozy-tomato-borscht",
    "name": "Cozy Tomato Borscht",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "crawling-firecracker-bug",
    "name": "Crawling Firecracker Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "crayfish-avocado-cup",
    "name": "Crayfish Avocado Cup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cream-cake",
    "name": "Cream Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "creamy-white-radish-soup",
    "name": "Creamy White Radish Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "cupcake",
    "name": "Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "deer-cupcake",
    "name": "Deer Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "deer-paw-candy",
    "name": "Deer Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "dragonfruit-hermit-crab",
    "name": "Dragonfruit Hermit Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "dragonfruit-jam",
    "name": "Dragonfruit Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "dung-beetle",
    "name": "Dung Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "dust-bug",
    "name": "Dust Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eastern-lubber-grasshopper",
    "name": "Eastern Lubber Grasshopper",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "edible-star-powder",
    "name": "Edible Star Powder",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eerie-pumpkin-bowl",
    "name": "Eerie Pumpkin Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eerie-pumpkin-pie",
    "name": "Eerie Pumpkin Pie",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eerie-pumpkin-soup",
    "name": "Eerie Pumpkin Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "egg-dumpling",
    "name": "Egg Dumpling",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "egg-pudding",
    "name": "Egg Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "egg-rice-bowl-banchos-pick",
    "name": "Egg Rice Bowl (Bancho's Pick)",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "eggplant-pasta",
    "name": "Eggplant Pasta",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fermented-dough",
    "name": "Fermented Dough",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ferret-cupcake",
    "name": "Ferret Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ferret-paw-candy",
    "name": "Ferret Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fiddlehead-celtuce-taco",
    "name": "Fiddlehead Celtuce Taco",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "firecracker-bug",
    "name": "Firecracker Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "firefly-squid",
    "name": "Firefly Squid",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fish-chips",
    "name": "Fish & Chips",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "flame-skimmer",
    "name": "Flame Skimmer",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "flat-white",
    "name": "Flat White",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "flatback-turtle",
    "name": "Flatback Turtle",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "flower-cake",
    "name": "Flower Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "flying-firecracker-bug",
    "name": "Flying Firecracker Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fox-cupcake",
    "name": "Fox Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fox-paw-candy",
    "name": "Fox Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fried-shrimp-sushi-banchos-pick",
    "name": "Fried Shrimp Sushi (Bancho's Pick)",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "frozen-sausage",
    "name": "Frozen Sausage",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fruit-jam-meatball",
    "name": "Fruit Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fruit-juice",
    "name": "Fruit Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "fruit-princess-cake",
    "name": "Fruit Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ghost-frog",
    "name": "Ghost Frog",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ghost-lollipop",
    "name": "Ghost Lollipop",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "gin-matsuba-koi",
    "name": "Gin Matsuba Koi",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "glass-rose-seed",
    "name": "Glass Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "glasswort",
    "name": "Glasswort",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "glasswort-shrimp-fried-rice",
    "name": "Glasswort & Shrimp Fried Rice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "gold-bug",
    "name": "Gold Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-clockwork-ladybug",
    "name": "Golden Clockwork Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-dung-beetle",
    "name": "Golden Dung Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-koi",
    "name": "Golden Koi",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-mussel",
    "name": "Golden Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "golden-pheasant",
    "name": "Golden Pheasant",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grape-cloud-candy",
    "name": "Grape Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grape-ice-cream",
    "name": "Grape Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grape-jam-meatball",
    "name": "Grape Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grape-juice",
    "name": "Grape Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grape-princess-cake",
    "name": "Grape Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "gray-bouncy-dust-insect",
    "name": "Gray Bouncy Dust Insect",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "gray-camping-sparrow",
    "name": "Gray Camping Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "gray-clockwork-sparrow",
    "name": "Gray Clockwork Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "great-black-firefly",
    "name": "Great Black Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-bath-towel-mako-shark",
    "name": "Green Bath-Towel Mako Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-bouncy-dust-bug",
    "name": "Green Bouncy Dust Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-camping-sparrow",
    "name": "Green Camping Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-cranesbill",
    "name": "Green Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-cranesbill-seed",
    "name": "Green Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-dung-beetle",
    "name": "Green Dung Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-flower-chafer",
    "name": "Green Flower Chafer",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-hat-stock-dove",
    "name": "Green Hat Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-jello-fish",
    "name": "Green Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-light-firefly",
    "name": "Green Light Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-light-jellyfish",
    "name": "Green Light Jellyfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-light-sea-star",
    "name": "Green Light Sea Star",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-starry-stock-dove",
    "name": "Green Starry Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "green-starry-swan",
    "name": "Green Starry Swan",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grey-mantled-albatross",
    "name": "Grey-mantled Albatross",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-mushroom",
    "name": "Grilled Mushroom",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-shiitake",
    "name": "Grilled Shiitake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-squid-w-apple-jam",
    "name": "Grilled Squid w/ Apple Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-squid-w-blueberry-jam",
    "name": "Grilled Squid w/ Blueberry Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-squid-w-fruit-jam",
    "name": "Grilled Squid w/ Fruit Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-squid-w-pineapple-jam",
    "name": "Grilled Squid w/ Pineapple Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-squid-w-starfruit-jam",
    "name": "Grilled Squid w/ Starfruit Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grilled-squid-w-strawberry-jam",
    "name": "Grilled Squid w/ Strawberry Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grimkin-pumpkin-bowl",
    "name": "Grimkin Pumpkin Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grimkin-pumpkin-pie",
    "name": "Grimkin Pumpkin Pie",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "grimkin-pumpkin-soup",
    "name": "Grimkin Pumpkin Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "hanging-firecracker-bug",
    "name": "Hanging Firecracker Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-apple-yogurt-bowl",
    "name": "Harvest Apple Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-black-diamond-mussel",
    "name": "Harvest Black Diamond Mussel",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-blue-diamond-mussel",
    "name": "Harvest Blue Diamond Mussel",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-blueberry-yogurt-bowl",
    "name": "Harvest Blueberry Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-corn-toast",
    "name": "Harvest Corn Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-golden-mussel",
    "name": "Harvest Golden Mussel",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-grape-yogurt-bowl",
    "name": "Harvest Grape Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-jade-mussel",
    "name": "Harvest Jade Mussel",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-lettuce-toast",
    "name": "Harvest Lettuce Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-mandarin-yogurt-bowl",
    "name": "Harvest Mandarin Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-matsutake-soup",
    "name": "Harvest Matsutake Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-meal",
    "name": "Harvest Meal",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-mussel",
    "name": "Harvest Mussel",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-nut-yogurt-bowl",
    "name": "Harvest Nut Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-nuts",
    "name": "Harvest Nuts",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-pineapple-yogurt-bowl",
    "name": "Harvest Pineapple Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-purple-diamond-mussel",
    "name": "Harvest Purple Diamond Mussel",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-raspberry-yogurt-bowl",
    "name": "Harvest Raspberry Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-strawberry-yogurt-bowl",
    "name": "Harvest Strawberry Yogurt Bowl",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-tomato-toast",
    "name": "Harvest Tomato Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "harvest-yogurt",
    "name": "Harvest Yogurt",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ice-bug",
    "name": "Ice Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ice-cream",
    "name": "Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "iced-cup-coffee",
    "name": "Iced-Cup Coffee",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "iced-cup-latte",
    "name": "Iced-Cup Latte",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "indigo-hanging-dust-bug",
    "name": "Indigo Hanging Dust Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "indigo-jello-fish",
    "name": "Indigo Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "inflatable-mallard",
    "name": "Inflatable Mallard",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "inflatable-ruddy-shelduck",
    "name": "Inflatable Ruddy Shelduck",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "inflatable-smew",
    "name": "Inflatable Smew",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "inflatable-wigeon",
    "name": "Inflatable Wigeon",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jade-mussel",
    "name": "Jade Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jady-blue-jellyfish-tartare",
    "name": "Jady Blue Jellyfish Tartare",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jady-green-jellyfish-tartare",
    "name": "Jady Green Jellyfish Tartare",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jady-jellyfish-tartare",
    "name": "Jady Jellyfish Tartare",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jady-purple-jellyfish-tartare",
    "name": "Jady Purple Jellyfish Tartare",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "japanese-flying-squid",
    "name": "Japanese Flying Squid",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jello-fish",
    "name": "Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jelly-treatsure-firefly",
    "name": "Jelly Treatsure Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jellybean-treatsure-butterfly",
    "name": "Jellybean Treatsure Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "jumping-firecracker-bug",
    "name": "Jumping Firecracker Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "kissing-fish",
    "name": "Kissing Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "koi",
    "name": "Koi",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "kuromi-crepe",
    "name": "Kuromi Crepe",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lady-amherst-s-pheasant",
    "name": "Lady Amherst's Pheasant",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "large-chocolate-mooncake",
    "name": "Large Chocolate Mooncake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "large-egg-yolk-mooncake",
    "name": "Large Egg Yolk Mooncake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "large-moon-rabbit-snow-skin-mooncake",
    "name": "Large Moon Rabbit Snow Skin Mooncake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "light-firefly",
    "name": "Light Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "light-sea-star",
    "name": "Light Sea Star",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "little-egret",
    "name": "Little Egret",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lollipop-treatsure-dragonfly",
    "name": "Lollipop Treatsure Dragonfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "lychee-shieldbug",
    "name": "Lychee Shieldbug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-cake",
    "name": "Mandarin Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-cloud-candy",
    "name": "Mandarin Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-cupcake",
    "name": "Mandarin Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-duck",
    "name": "Mandarin Duck",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-fish",
    "name": "Mandarin Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-frosted-pancake",
    "name": "Mandarin Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-hermit-crab",
    "name": "Mandarin Hermit Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-ice-cream",
    "name": "Mandarin Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-jam-meatball",
    "name": "Mandarin Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-juice",
    "name": "Mandarin Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-pearl-cake",
    "name": "Mandarin Pearl Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-princess-cake",
    "name": "Mandarin Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mandarin-pudding",
    "name": "Mandarin Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "marinade-powder",
    "name": "Marinade Powder",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "marinated-catfish-fillets",
    "name": "Marinated Catfish Fillets",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "marinated-fillets",
    "name": "Marinated Fillets",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "marinated-paddlefish-fillets",
    "name": "Marinated Paddlefish Fillets",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "marinated-pufferfish-fillets",
    "name": "Marinated Pufferfish Fillets",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "marshmallow",
    "name": "Marshmallow",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mashed-potato",
    "name": "Mashed Potato",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "meat-dumpling",
    "name": "Meat Dumpling",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "milk-cupcake",
    "name": "Milk Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "milk-toast",
    "name": "Milk Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mint",
    "name": "Mint",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mixed-vegetable-puree",
    "name": "Mixed Vegetable Puree",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mixed-vegetable-soup",
    "name": "Mixed Vegetable Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "moon-rabbit-snow-skin-mooncake",
    "name": "Moon Rabbit Snow Skin Mooncake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mooncake",
    "name": "Mooncake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "morpho-luna",
    "name": "Morpho Luna",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mummy-cat-drink",
    "name": "Mummy Cat Drink",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "mustard-greens-celtuce-taco",
    "name": "Mustard Greens Celtuce Taco",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "my-melody-crepe",
    "name": "My Melody Crepe",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "new-year-fortune-fish",
    "name": "New Year Fortune Fish",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ocean-feast",
    "name": "Ocean Feast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ocean-iced-drink",
    "name": "Ocean Iced Drink",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "ocellated-turkey",
    "name": "Ocellated Turkey",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "olive-ridley-turtle",
    "name": "Olive Ridley Turtle",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-calla-lily-seed",
    "name": "Orange Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-camping-sparrow",
    "name": "Orange Camping Sparrow",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-cranesbill",
    "name": "Orange Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-cranesbill-seed",
    "name": "Orange Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-dandelion",
    "name": "Orange Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-hyacinth",
    "name": "Orange Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-jello-fish",
    "name": "Orange Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-moth-orchid",
    "name": "Orange Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-rose-seed",
    "name": "Orange Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "orange-tulip-seed",
    "name": "Orange Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "oriental-magpie",
    "name": "Oriental Magpie",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "original-cloud-candy",
    "name": "Original Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "original-frosted-pancake",
    "name": "Original Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "palmier-treatsure-butterfly",
    "name": "Palmier Treatsure Butterfly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "panda-cupcake",
    "name": "Panda Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "panda-paw-candy",
    "name": "Panda Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "parsley",
    "name": "Parsley",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pasta",
    "name": "Pasta",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pea",
    "name": "Pea",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pea-puree",
    "name": "Pea Puree",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pea-soup",
    "name": "Pea Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-calla-lily-seed",
    "name": "Peach Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-cranesbill",
    "name": "Peach Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-cranesbill-seed",
    "name": "Peach Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-dandelion",
    "name": "Peach Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-hyacinth",
    "name": "Peach Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-moth-orchid",
    "name": "Peach Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-rose-seed",
    "name": "Peach Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "peach-tulip-seed",
    "name": "Peach Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "permit",
    "name": "Permit",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "persimmon",
    "name": "Persimmon",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "persimmon-ruyi-cake",
    "name": "Persimmon Ruyi Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pied-falconet",
    "name": "Pied Falconet",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pied-kingfisher",
    "name": "Pied Kingfisher",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple-cloud-candy",
    "name": "Pineapple Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple-ice-cream",
    "name": "Pineapple Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple-jam-meatball",
    "name": "Pineapple Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple-juice",
    "name": "Pineapple Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple-princess-cake",
    "name": "Pineapple Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pineapple-pudding",
    "name": "Pineapple Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-atlantic-salmon",
    "name": "Pink Atlantic Salmon",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-calla-lily-seed",
    "name": "Pink Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-cranesbill",
    "name": "Pink Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-cranesbill-seed",
    "name": "Pink Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-dandelion",
    "name": "Pink Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-hanging-dust-bug",
    "name": "Pink Hanging Dust Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-hat-stock-dove",
    "name": "Pink Hat Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-hyacinth",
    "name": "Pink Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-king-crab",
    "name": "Pink King Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-light-firefly",
    "name": "Pink Light Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-memory",
    "name": "Pink Memory",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-moth-orchid",
    "name": "Pink Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-necked-firefly",
    "name": "Pink-Necked Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-rose-seed",
    "name": "Pink Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-seahorse",
    "name": "Pink Seahorse",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-shortfin-mako-shark",
    "name": "Pink Shortfin Mako Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-swordfish",
    "name": "Pink Swordfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pink-tulip-seed",
    "name": "Pink Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pomarine-skua",
    "name": "Pomarine Skua",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "potato",
    "name": "Potato",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "psionic-indian-fritillary",
    "name": "Psionic Indian Fritillary",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "psionic-luna-moth",
    "name": "Psionic Luna Moth",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "psionic-queen-alexandra-s-birdwing",
    "name": "Psionic Queen Alexandra's Birdwing",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "psionic-rimmed-window-firefly",
    "name": "Psionic Rimmed Window Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pudding",
    "name": "Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "puff-treatsure-ladybug",
    "name": "Puff Treatsure Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pumpkin",
    "name": "Pumpkin",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "pumpkin-lollipop",
    "name": "Pumpkin Lollipop",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-calla-lily-seed",
    "name": "Purple Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-dandelion",
    "name": "Purple Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-diamond-mussel",
    "name": "Purple Diamond Mussel",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-dung-beetle",
    "name": "Purple Dung Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-floating-dust-bug",
    "name": "Purple Floating Dust Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-hyacinth",
    "name": "Purple Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-jello-fish",
    "name": "Purple Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-light-firefly",
    "name": "Purple Light Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-light-jellyfish",
    "name": "Purple Light Jellyfish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-light-sea-star",
    "name": "Purple Light Sea Star",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-moth-orchid",
    "name": "Purple Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-rose-seed",
    "name": "Purple Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-starry-stock-dove",
    "name": "Purple Starry Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-starry-swan",
    "name": "Purple Starry Swan",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "purple-tulip-seed",
    "name": "Purple Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "qiaoguo",
    "name": "Qiaoguo",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rajah-brooke-s-birdwing",
    "name": "Rajah Brooke's Birdwing",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-cloud-candy",
    "name": "Raspberry Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-cupcake",
    "name": "Raspberry Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-frosted-pancake",
    "name": "Raspberry Frosted Pancake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-hermit-crab",
    "name": "Raspberry Hermit Crab",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-ice-cream",
    "name": "Raspberry Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-jam-meatball",
    "name": "Raspberry Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-juice",
    "name": "Raspberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-pearl-cake",
    "name": "Raspberry Pearl Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-princess-cake",
    "name": "Raspberry Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-pudding",
    "name": "Raspberry Pudding",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "raspberry-toast",
    "name": "Raspberry Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-clockwork-ladybug",
    "name": "Red Clockwork Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-cranesbill",
    "name": "Red Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-cranesbill-seed",
    "name": "Red Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-crowned-crane",
    "name": "Red-Crowned Crane",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-dandelion",
    "name": "Red Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-dung-beetle",
    "name": "Red Dung Beetle",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-hyacinth",
    "name": "Red Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-jello-fish",
    "name": "Red Jello Fish",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-koi",
    "name": "Red Koi",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-moth-orchid",
    "name": "Red Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-rose-seed",
    "name": "Red Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "red-tulip-seed",
    "name": "Red Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rimmed-window-firefly",
    "name": "Rimmed Window Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "rock-bug",
    "name": "Rock Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "roll-cake-treatsure-snail",
    "name": "Roll Cake Treatsure Snail",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "roseate-spoonbill",
    "name": "Roseate Spoonbill",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "royal-palm-turkey",
    "name": "Royal Palm Turkey",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "salsa",
    "name": "Salsa",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "salsa-rippled-potato-chips",
    "name": "Salsa Rippled Potato Chips",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sauna-hat-sea-turtle",
    "name": "Sauna Hat Sea Turtle",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "savory-duo-bucket",
    "name": "Savory Duo Bucket",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "scallop",
    "name": "Scallop",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-grape",
    "name": "Sea Grape",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-grape-shiitake-chawanmushi",
    "name": "Sea Grape & Shiitake Chawanmushi",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-otter-cupcake",
    "name": "Sea Otter Cupcake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-otter-paw-candy",
    "name": "Sea Otter Paw Candy",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sea-slug",
    "name": "Sea Slug",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "seashell-pearl-cake",
    "name": "Seashell Pearl Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-cranesbill",
    "name": "Selene Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-cranesbill-seed",
    "name": "Selene Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-dandelion",
    "name": "Selene Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-moth-orchid",
    "name": "Selene Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "selene-rose-seed",
    "name": "Selene Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "simmered-claypot-soup",
    "name": "Simmered Claypot Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "small-xmas-cake",
    "name": "Small Xmas Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "snow-bug",
    "name": "Snow Bug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "snowy-window-firefly",
    "name": "Snowy Window Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "spectral-octopus",
    "name": "Spectral Octopus",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "spirulina-powder",
    "name": "Spirulina Powder",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "springday-picnic-set",
    "name": "Springday Picnic Set",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "springday-raspberry-black-tea",
    "name": "Springday Raspberry Black Tea",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starfruit",
    "name": "Starfruit",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starfruit-jam",
    "name": "Starfruit Jam",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starfruit-pearl-cake",
    "name": "Starfruit Pearl Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-apple-donut",
    "name": "Starry Apple Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-apple-mint-milk",
    "name": "Starry Apple Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-blueberry-donut",
    "name": "Starry Blueberry Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-blueberry-mint-milk",
    "name": "Starry Blueberry Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-fruit-donut",
    "name": "Starry Fruit Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-fruit-mint-milk",
    "name": "Starry Fruit Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-grape-donut",
    "name": "Starry Grape Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-grape-mint-milk",
    "name": "Starry Grape Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-mandarin-donut",
    "name": "Starry Mandarin Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-mandarin-mint-milk",
    "name": "Starry Mandarin Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-meal",
    "name": "Starry Meal",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-pineapple-donut",
    "name": "Starry Pineapple Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-pineapple-mint-milk",
    "name": "Starry Pineapple Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-raspberry-donut",
    "name": "Starry Raspberry Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-raspberry-mint-milk",
    "name": "Starry Raspberry Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-strawberry-donut",
    "name": "Starry Strawberry Donut",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-strawberry-mint-milk",
    "name": "Starry Strawberry Mint Milk",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "starry-swan",
    "name": "Starry Swan",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "steak-w-mashed-white-radish",
    "name": "Steak w/ Mashed White Radish",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "steamed-cured-meat",
    "name": "Steamed Cured Meat",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "steamed-ribs-w-rice-powder",
    "name": "Steamed Ribs w/ Rice Powder",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "strawberry-cloud-candy",
    "name": "Strawberry Cloud Candy",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "strawberry-ice-cream",
    "name": "Strawberry Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "strawberry-jam-meatball",
    "name": "Strawberry Jam Meatball",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "strawberry-juice",
    "name": "Strawberry Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "strawberry-princess-cake",
    "name": "Strawberry Princess Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "striped-bath-towel-mako-shark",
    "name": "Striped Bath-Towel Mako Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "striped-sauna-hat-sea-turtle",
    "name": "Striped Sauna Hat Sea Turtle",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sulkowsky-s-morpho",
    "name": "Sulkowsky's Morpho",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-calla-lily-seed",
    "name": "Sunglow Calla Lily Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-cranesbill",
    "name": "Sunglow Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-cranesbill-seed",
    "name": "Sunglow Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-hyacinth",
    "name": "Sunglow Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-moth-orchid",
    "name": "Sunglow Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-rose-seed",
    "name": "Sunglow Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "sunglow-tulip-seed",
    "name": "Sunglow Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tall-mustard-celtuce-taco",
    "name": "Tall Mustard Celtuce Taco",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tiger-puffer",
    "name": "Tiger Puffer",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toast",
    "name": "Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-apple-marshmallow",
    "name": "Toasted Apple Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-blueberry-marshmallow",
    "name": "Toasted Blueberry Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-mandarin-marshmallow",
    "name": "Toasted Mandarin Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-marshmallow",
    "name": "Toasted Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-pineapple-marshmallow",
    "name": "Toasted Pineapple Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-raspberry-marshmallow",
    "name": "Toasted Raspberry Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "toasted-strawberry-marshmallow",
    "name": "Toasted Strawberry Marshmallow",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tomato-juice",
    "name": "Tomato Juice",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "tomato-seafood-soup",
    "name": "Tomato Seafood Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "treatsure-candy-roll-cake",
    "name": "Treatsure Candy Roll Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "treatsure-crispy-roll-cake",
    "name": "Treatsure Crispy Roll Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "treatsure-jelly-roll-cake",
    "name": "Treatsure Jelly Roll Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "treatsure-jellybean-roll-cake",
    "name": "Treatsure Jellybean Roll Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "treatsure-puff-roll-cake",
    "name": "Treatsure Puff Roll Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "treatsure-roll-cake",
    "name": "Treatsure Roll Cake",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "turkey",
    "name": "Turkey",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "utopia-meal",
    "name": "Utopia Meal",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "utopian-corn-hotdog",
    "name": "Utopian Corn Hotdog",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "utopian-grilled-sausage",
    "name": "Utopian Grilled Sausage",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "utopian-lettuce-hotdog",
    "name": "Utopian Lettuce Hotdog",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "utopian-original-hotdog",
    "name": "Utopian Original Hotdog",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "utopian-tomato-hotdog",
    "name": "Utopian Tomato Hotdog",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "vanilla",
    "name": "Vanilla",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-apple-ice-cream",
    "name": "Waffle & Apple Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-blueberry-ice-cream",
    "name": "Waffle & Blueberry Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-grape-ice-cream",
    "name": "Waffle & Grape Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-mandarin-ice-cream",
    "name": "Waffle & Mandarin Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-pineapple-ice-cream",
    "name": "Waffle & Pineapple Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-raspberry-ice-cream",
    "name": "Waffle & Raspberry Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-strawberry-ice-cream",
    "name": "Waffle & Strawberry Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "waffle-vanilla-ice-cream",
    "name": "Waffle & Vanilla Ice Cream",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wakame",
    "name": "Wakame",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wakame-meatball-soup",
    "name": "Wakame Meatball Soup",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "wandering-albatross",
    "name": "Wandering Albatross",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-banded-erebus-moth",
    "name": "White-banded Erebus Moth",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-clockwork-ladybug",
    "name": "White Clockwork Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-cranesbill",
    "name": "White Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-cranesbill-seed",
    "name": "White Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-dandelion",
    "name": "White Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-dragonfruit",
    "name": "White Dragonfruit",
    "kind": "ingredient",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-faced-storm-petrel",
    "name": "White-Faced Storm Petrel",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-hat-stock-dove",
    "name": "White Hat Stock Dove",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-hyacinth",
    "name": "White Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-moth-orchid",
    "name": "White Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-rose-seed",
    "name": "White Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-sauna-hat-sea-turtle",
    "name": "White Sauna Hat Sea Turtle",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-spoonbill",
    "name": "White Spoonbill",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-tulip-seed",
    "name": "White Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "white-winged-tern",
    "name": "White-Winged Tern",
    "kind": "bird",
    "tags": [],
    "aliases": []
  },
  {
    "id": "whole-wheat-toast",
    "name": "Whole Wheat Toast",
    "kind": "dish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-bath-towel-mako-shark",
    "name": "Yellow Bath-Towel Mako Shark",
    "kind": "fish",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-clockwork-ladybug",
    "name": "Yellow Clockwork Ladybug",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-cranesbill",
    "name": "Yellow Cranesbill",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-cranesbill-seed",
    "name": "Yellow Cranesbill Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-dandelion",
    "name": "Yellow Dandelion",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-hyacinth",
    "name": "Yellow Hyacinth",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-light-firefly",
    "name": "Yellow Light Firefly",
    "kind": "insect",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-moth-orchid",
    "name": "Yellow Moth Orchid",
    "kind": "flower",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-rose-seed",
    "name": "Yellow Rose Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  },
  {
    "id": "yellow-tulip-seed",
    "name": "Yellow Tulip Seed",
    "kind": "seed",
    "tags": [],
    "aliases": []
  }
];
